
import React, { Component } from 'react'
import styled from 'styled-components'
import { rem } from 'polished'

const Root = styled.div<{ show: boolean }>`
  display: ${({ show }) => show ? 'block' : 'none'};
  padding: ${rem(20)};
  color: ${({ theme }) => theme.palette.neutral.one};
  text-align: center;
  background: ${({ theme }) => theme.palette.messaging.warning.light};
`

interface Props {
  forceShow?: boolean;
}

interface State {
  isEnabled: boolean;
}

class CookiesDisabledWarning extends Component<React.PropsWithChildren<Props>, State> {
  constructor(props) {
    super(props)
    this.state = {
      isEnabled: true,
    }
  }

  componentDidMount() {
    this.setState({
      isEnabled: this.areCookiesEnabled(),
    })
  }

  areCookiesEnabled() {
    if (window.navigator.cookieEnabled) return true
    document.cookie = 'cookietest=1'
    const ret = document.cookie.includes('cookietest=')
    document.cookie = 'cookietest=1; expires=Thu, 01-Jan-1970 00:00:01 GMT'
    return ret
  }

  render() {
    const { forceShow } = this.props
    return (
      <Root show={!this.state.isEnabled || forceShow}>
        Oops! Your browser seems to have cookies disabled. Make sure cookies are enabled or open a new window.
      </Root>
    )
  }
}

export default CookiesDisabledWarning
